export { productsCollectionsActions, reducer, saga } from './duck';
